import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloContact,cleanAloContact } from '@/models/alo/AloContact'

export default {
  getAllContact(): AxiosPromise<AlrContainer<Array<AloContact>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Contact`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloContact>>
      }]
    })
  },
  getFilterContact(dates : Array<Date>): AxiosPromise<AlrContainer<Array<AloContact>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/Contact/filter?from=${dates[0].toUTCString()}&to=${dates[1].toUTCString()}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloContact>>
      }]
    })
  },
  getMinDate(){
    return apiHelpers.apiCall({ 
      url: `/webapi/Contact/min-date`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<string>
      }]
    })
  },
  getContact(id:number):AxiosPromise<AlrContainer<AloContact>> {
    return  apiHelpers.apiCall({ 
      url: `/webapi/Contact/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<AloContact>
      }]
    })
  },
  saveContact(contact:AloContact):AxiosPromise<AlrContainer<AloContact>> {
    cleanAloContact(contact)
    if(contact.id) {
      return  apiHelpers.apiCall({ 
        url: `/webapi/Contact/${contact.id}`, 
        method: 'PUT',
        data: contact,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloContact>
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `/webapi/Contact`, 
        method: 'POST',
        data: contact,
        transformResponse: [function (data:string) {          
          return JSON.parse(data) as AlrContainer<AloContact>
        }]
      })    
    }
  },
  deleteContact(id:number){
    return  apiHelpers.apiCall({ 
      url: `/webapi/Contact/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<number>
      }]
    })
  },
  executeActionOnSelection(payload:{conIds:Array<number>,action:string,data?:any}){
    return  apiHelpers.apiCall({ 
      url: `/webapi/Contact/execute`,
      method: 'PUT',
      data:payload,
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloContact>>
      }]
    })    
  }
}
